export default __webpack_public_path__ + "static/media/eye_close.814ca1c6.svg";